// extracted by mini-css-extract-plugin
export default {"immersiveHeader":"ImmersiveHeader_immersiveHeader__YL1FW","dark":"ImmersiveHeader_dark__NMOlr","light":"ImmersiveHeader_light__41zN8","sticky":"ImmersiveHeader_sticky__fm0nN"};